import React from 'react';
import { Instagram, Linkedin } from 'lucide-react';

const footerLinks = {
  product: [
    { name: 'Ferramentas', href: '#tools' },
    { name: 'FAQ', href: '#faq' },
    { name: 'Blog', href: 'https://blog.lawx.ai/blog'},
    { name: 'API', href: 'https://api.whatsapp.com/send?phone=5584999869794&text=Ol%C3%A1!%20Quero%20entender%20sobre%20a%20API'}
  ],
  legal: [
    { name: 'Política de Privacidade', href: '/privacy' },
    { name: 'Termos de Uso', href: '/terms-of-use' }
  ]
};

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#081428]/80 backdrop-blur-lg">
      <div className="container mx-auto px-6 py-12">
        {/* Logo and social links */}
        <div className="flex flex-col md:flex-row justify-between items-center mb-12">
          <a href="/">
            <img 
              src="https://imagedelivery.net/xVIHcLAprA3z5a44SkpIlA/bae752f2-e9b0-4924-58be-186e7e7c0c00/public" 
              alt="LawX Logo" 
              className="h-8 w-auto"
            />
          </a>
          
          <div className="flex space-x-6 mt-6">
            {[
              { Icon: Instagram, href: 'https://www.instagram.com/lawx.ai/' },
              { Icon: Linkedin, href: 'https://www.linkedin.com/company/lawxai/' }
            ].map(({ Icon, href }, index) => (
              <a
                key={index}
                href={href}
                className="text-gray-400 hover:text-[#28E7C5] transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon className="w-6 h-6" />
              </a>
            ))}
          </div>
        </div>

        {/* Links grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="text-lg font-semibold mb-4 capitalize">{category}</h3>
              <ul className="space-y-3">
                {links.map((link, index) => (
                  <li key={index}>
                    <a
                      href={link.href}
                      className="text-gray-400 hover:text-[#28E7C5] transition-colors"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom section */}
        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-white/10">
          <div className="flex flex-col items-center md:items-start">
            <p className="text-gray-400 text-sm mb-1">
              © 2025 LawX. Todos direitos reservados.
            </p>
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              Melhor IA para advogados!
            </p>
          </div>
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            CNPJ: 41.995.178/0001-05
          </p>
          <div className="flex space-x-6 text-sm">
            <a href="/privacy" className="text-gray-400 hover:text-[#28E7C5] transition-colors">
              Política de Privacidade
            </a>
            <a href="/terms-of-use" className="text-gray-400 hover:text-[#28E7C5] transition-colors">
              Termos de Uso
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}